import { render, staticRenderFns } from "./Exports.vue?vue&type=template&id=50f6fbc8&scoped=true"
import script from "./Exports.vue?vue&type=script&lang=js"
export * from "./Exports.vue?vue&type=script&lang=js"
import style0 from "./Exports.vue?vue&type=style&index=0&id=50f6fbc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f6fbc8",
  null
  
)

export default component.exports